<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-md-12">
                <div mat-dialog-title>
                    <div style="text-align: center;color: red;">Are you sure want to create a new vendor ?</div>
                </div>
            </div>
        </div>

        <div class="mat-dialog-content">
            <form (ngSubmit)="onSubmit()">

                <!-- <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Vendor Name</mat-label>
                        <input matInput  [(ngModel)]="data.phone" name="data.phone" required>
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div> -->

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Vendor Name</mat-label>
                        <input matInput [(ngModel)]="data.vendorId" name="data.vendorId" required readonly="true">
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Email</mat-label>
                        <input matInput [(ngModel)]="data.email" name="data.email" required readonly="true">
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>

                <alert></alert>
                <div class="buttonRow">
                    <button mat-raised-button class="button" type="submit" (click)="onNoClick()"
                        style="margin:0 10px 10px 0;">Yes</button>
                    <button type="reset" mat-raised-button [mat-dialog-close]="true" class="buttonReset">No</button>
                </div>
            </form>
        </div>
    </div>
</div>